<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <div id="member-filters">
    <div v-for="(filter, idx) in filters" :key="idx">
      <FilterOption
        :key="filter.key"
        :item="filter"
        :change="updateFilter"
        :clear="clear"
        :loading="loading"
        :maxWidth="maxWidth"
        :ellipsis="ellipsis"
      />
    </div>
    <div class="nav-button" @click="toggle('showRightSidebar', true)">
      <img
        alt="test"
        src="@shared/assets/img/leads/filter-white.png"
        class="img-size-24"
      />
      <div class="white-f-16">Filter</div>
    </div>
  </div>
</template>

<script>
import orderMixin from '@shared/mixins/orderMixin';
import FilterOption from './FilterOption.vue';

export default {
  name: 'MemberOrdersFilters',
  components: {
    FilterOption,
  },
  mixins: [orderMixin],
  props: {
    loading: Boolean,
    filters: {
      type: Array,
      default() {
        return [];
      },
    },
    change: Function,
    clear: Function,
    toggle: Function,
    width: {
      type: String,
      default: '100%',
    },
    maxWidth: {
      type: String,
      default: 'auto',
    },
    ellipsis: {
      type: String,
      default: '',
    },
  },
  watch: {
    filters(nv) {
      if (this.$route.query.techId && nv.find((x) => x.key === 'techs').options.find((x)=> x.value === +this.$route.query.techId) && !this.firstLoad) {
        this.updateFilter(nv.find((x) => x.key === 'techs').options.find((x)=>x.value === +this.$route.query.techId), 'techs');
        this.firstLoad = true;
      }
    },
  },
  methods: {
    updateFilter(option, key) {
      const newFilters = this.filters.map((op) => {
        const newOp = { ...op };
        if (newOp.key === key) {
          newOp.active = true;
          newOp.activeOption = option;
        }
        return newOp;
      });
      this.change(newFilters, key);
    },
  },
};
</script>

<style lang="scss" scoped>
#member-filters {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  position: sticky;
  top: 60px;
  gap: 10px;
  z-index: 5;
  font-size: 0.85em;
  .nav-button {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 44px;
    padding: 0 12px;
    border-radius: 6px;
    background-color: $N95;
    cursor: pointer;
    &.active {
      background-color: $NBLUE110;
      border-radius: 6px;
    }
    &:hover {
      background-color: $N90;
      border-radius: 6px;
    }
  }
}
</style>
